import { Skeleton } from '@heroui/react';
import { ReactNode } from 'react';

export type MenuListItemProps = {
  isLoading?: boolean;
  title?: string;
  description?: ReactNode;
  weight?: 'semibold' | 'normal';
  variant?: 'col' | 'row';
};

export const MenuListItem = ({
  isLoading = false,
  title = 'Заголовок',
  description = 'Описание',
  variant = 'row',
  weight = 'normal',
}: MenuListItemProps) => {
  const variantClass = {
    row: 'flex-row justify-between items-center',
    col: 'flex-col items-start gap-y-2',
  };
  return (
    <div className={`flex ${variantClass[variant]}`}>
      <Skeleton isLoaded={!isLoading} className="max-w-80">
        <p className="text-sm lg:text-base text-[#60656C]">{title}</p>
      </Skeleton>

      <Skeleton isLoaded={!isLoading} className="max-w-80">
        <div className={`text-sm lg:text-base text-[#222222] font-${weight}`}>
          {description}
        </div>
      </Skeleton>
    </div>
  );
};
